import { EditableCard } from "../../../components/editableCard.component";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { ApiSchemaPatient } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { UtilityDate } from "../../../utils/dateUtils";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const ImportantInfoCard = (props: Props) => {
  const { patientId } = useParams<{ patientId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Patient.Root()}/update/${patientId}`}
      title="Important info"
      isValidating={props.isValidating}
    >
      {props.isValidating ? (
        <TableCardPlaceholder rows={18} />
      ) : (
        <table className="w-100 ">
          {!!props.data?.gender && (
            <tr>
              <td className="p-3 border-bottom pe-2">Gender</td>
              <td className="p-3 border-bottom ps-2">{props.data?.gender}</td>
            </tr>
          )}
          {!!props.data?.email && (
            <tr>
              <td className="p-3 border-bottom pe-2">Email Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.email}</td>
            </tr>
          )}
          {!!props.data?.phoneNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">Phone Number</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.phoneNumber}
              </td>
            </tr>
          )}
          {!!props.data?.address && (
            <tr>
              <td className="p-3 border-bottom pe-2">Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.address}</td>
            </tr>
          )}
          {!!props.data?.apartmentNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">Apartment</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.apartmentNumber}
              </td>
            </tr>
          )}
          {!!props.data?.dateOfBirth && (
            <tr>
              <td className="p-3 border-bottom pe-2">Date Of Birth</td>
              <td className="p-3 border-bottom ps-2">
                {UtilityDate.formatDate(props.data?.dateOfBirth)}
              </td>
            </tr>
          )}
          {!!props.data?.insuranceId && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Member/insurance id number
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.insuranceId}
              </td>
            </tr>
          )}
          {!!props.data?.medicalCode && (
            <tr>
              <td className="p-3 border-bottom pe-2">Medical code</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.medicalCode}
              </td>
            </tr>
          )}
          {!!props.data?.totalUnit && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Total units (1 unit = 15 minutes):{" "}
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.totalUnit} Units.{" "}
                <span>
                  ({props.data?.totalUnit && props.data?.totalUnit * 15}{" "}
                  minutes)
                </span>
              </td>
            </tr>
          )}
          {!!props.data?.perUnitCost && !!props.data?.totalUnit && (
            <tr>
              <td className="p-3 border-bottom pe-2">Bill Amount</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.totalUnit * props.data?.perUnitCost}
              </td>
            </tr>
          )}
          {!!props.data?.serviceAuthorizationStartDate && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Service Authorization Start Date
              </td>
              <td className="p-3 border-bottom ps-2">
                {UtilityDate.formatDate(
                  props.data?.serviceAuthorizationStartDate
                )}
              </td>
            </tr>
          )}
          {!!props.data?.serviceAuthorizationStartDate && (
            <tr
              className={`${
                new Date(props.data?.serviceAuthorizationEndDate!).getDate() <
                new Date().getDate()
                  ? "text-red-300"
                  : ""
              }`}
            >
              <td className="p-3 border-bottom pe-2">
                Service Authorization End Date
              </td>
              <td className="p-3 border-bottom ps-2">
                {UtilityDate.formatDate(
                  props.data?.serviceAuthorizationEndDate
                )}
              </td>
            </tr>
          )}

          {!!props.data?.insuranceTypeName && (
            <tr>
              <td className="p-3 border-bottom pe-2">Insurance type</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.insuranceTypeName}
              </td>
            </tr>
          )}
          {!!props.data?.emergencyContactPersonName && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Emergency Contact Person Name
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.emergencyContactPersonName}
              </td>
            </tr>
          )}
          {!!props.data?.emergencyContactPersonPhone && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Emergency Contact Phone Number
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.emergencyContactPersonPhone}
              </td>
            </tr>
          )}
          {!!props.data?.caseManager && (
            <tr>
              <td className="p-3 border-bottom pe-2">Case Manager</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.caseManager}
              </td>
            </tr>
          )}
          {!!props.data?.caseManagerPhoneNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Case Manager Phone Number
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.caseManagerPhoneNumber}
              </td>
            </tr>
          )}
          {!!props.data?.caseManagerEmail && (
            <tr>
              <td className="p-3 border-bottom pe-2">Case Manager Email</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.caseManagerEmail}
              </td>
            </tr>
          )}
          <tr>
            <td className="p-3 border-bottom pe-2">Language(s)</td>
            <td className="p-3 border-bottom ps-2">
              {props.data?.languages?.length
                ? props.data?.languages?.join(", ")
                : "No Language"}
            </td>
          </tr>
          <tr>
            <td className="p-3 border-bottom pe-2">Transport</td>
            <td className="p-3 border-bottom ps-2">
              {!props.data?.isTransportAvailable && "Not"} Available
            </td>
          </tr>
        </table>
      )}
    </EditableCard>
  );
};
